import { useEffect, useMemo, useState } from "react";

export default function AutoImageSlider({
  images,
  alt = "Gallery image",
  className = "",
  imageClassName = "",
  interval = 3200,
  onImageError,
}) {
  const slides = useMemo(
    () => (images || []).filter(Boolean),
    [images],
  );
  const [active, setActive] = useState(0);

  useEffect(() => {
    setActive(0);
  }, [slides.length]);

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const timer = setInterval(() => {
      setActive((current) => (current + 1) % slides.length);
    }, interval);
    return () => clearInterval(timer);
  }, [interval, slides.length]);

  if (slides.length === 0) return null;

  return (
    <div className={`relative overflow-hidden ${className}`}>
      <div className="relative h-full w-full">
        {slides.map((src, index) => (
          <img
            key={`${src}-${index}`}
            src={src}
            alt={index === 0 ? alt : `${alt} ${index + 1}`}
            className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 ease-in-out ${
              active === index ? "opacity-100 z-10" : "opacity-0 z-0"
            } ${imageClassName}`}
            onError={onImageError}
          />
        ))}
      </div>

      {slides.length > 1 ? (
        <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-1.5 z-20">
          {slides.map((src, index) => (
            <button
              key={`${src}-dot-${index}`}
              type="button"
              aria-label={`Show image ${index + 1}`}
              onClick={() => setActive(index)}
              className={`h-1.5 rounded-full transition-all ${
                active === index ? "w-6 bg-white" : "w-1.5 bg-white/55"
              }`}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}
